import React, { useState } from 'react'
import { Link } from 'react-router'
import logo from '../img/logo.png'
import { navlink } from '../Data/dummydata'
import { Menu } from '@mui/icons-material'

function Header() {

    const [responsive, setResponsive] = useState(false)

    return (
        <>
            <header>
                <div className='container flexsb'>
                    <div className='logo'>
                        <img src={logo} alt='logo-image' data-aos="zoom-in-right" />
                    </div>
                    <div className={responsive ? 'hideMenu' : 'nav'}>
                        {navlink.map((links, i) => (
                            <Link to={links.url} key={i} data-aos="zoom-in-left">
                                {links.text}
                            </Link>
                        ))}
                    </div>
                    <button className='toggle' onClick={ () => setResponsive(!responsive)}>
                        <Menu className='icon'></Menu>
                    </button>
                </div>
            </header>
        </>
    )
}
export default Header